import HrAssignementSummary from "./HrAssignementSummary";
export default HrAssignementSummary;